import { useEmailLeads } from 'features/email-leads/hooks';
import { isAuthenticatedSelector } from 'features/user/redux/selectors';
import { FirebaseCollectionsType } from 'firebaseAPI';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFirestoreConnect } from 'react-redux-firebase';

const AppContainer: React.FC = (props) => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const { getEmailLeads } = useEmailLeads();

  /**
   * Get partner list
   */
  useFirestoreConnect({
    collection: FirebaseCollectionsType.PARTNERS,
    storeAs: FirebaseCollectionsType.PARTNERS,
  });

  useEffect(() => {
    onPageInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageInit = useCallback(() => {
    if (!isAuthenticated) {
      return;
    }

    Promise.all([getEmailLeads()]);
  }, [getEmailLeads, isAuthenticated]);

  return <>{props.children}</>;
};

export { AppContainer };
